interface ErrorDetailsProps {
  error: Error;
}

export const ErrorDetails = ({ error }: ErrorDetailsProps) => {
  if (!import.meta.env.DEV) {
    return null;
  }

  return (
    <details className="bg-destructive/5 border border-destructive/20 rounded-md p-4 mb-6 text-left">
      <summary className="text-body-small-semibold text-destructive mb-2 cursor-pointer">
        {
          // painel de debug exclusivo de DEV (import.meta.env.DEV); exceção "texto de devtool" da i18n.mdc §2
          "🔍 Detalhes Técnicos (Dev Only)"
        }
      </summary>
      <div className="mt-2">
        <p className="text-body-xsmall-semibold text-destructive mb-1">
          {error.name}: {error.message}
        </p>
        <pre className="text-body-xsmall-regular text-destructive/80 whitespace-pre-wrap break-all overflow-auto max-h-48">
          {error.stack}
        </pre>
      </div>
    </details>
  );
};
